/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React, { useState } from "react";
import { Box, List, ListItem, ListItemButton, ListItemText, Paper, Tooltip } from "@mui/material";
import { Setter, User } from "../../utils/Interfaces";
import { customScrollbarStyle, sortUsersByName } from "../../utils/Functions";

export interface AssigneesListProps {
    assignees: User[];
    setSelectedUser: Setter<User>;
    subtextFunction: (user: User) => string;
}

const AssigneesList = (props: AssigneesListProps) => {
    const { assignees, setSelectedUser, subtextFunction } = props;

    const [selectedUserIndex, setSelectedUserIndex] = useState<number>(0);

    let shallowCopy: User[] = sortUsersByName(assignees);

    return (
        <Paper sx={{ borderRadius: "8px 8px 8px 8px" }}>
            <Box sx={{ maxHeight: "calc(100vh - 150px)", height: "100%", overflowY: "auto", ...customScrollbarStyle() }}>
                <List>
                    {shallowCopy.map((user: User, index: number) => {
                        return (
                            <Tooltip title={`Manage assignments for ${user.first_name} ${user.last_name}.`} key={index}>
                                <ListItem
                                    disablePadding
                                    selected={selectedUserIndex === index}
                                    onClick={() => {
                                        setSelectedUserIndex(index);
                                        setSelectedUser(user);
                                    }}
                                >
                                    <ListItemButton>
                                        <ListItemText
                                            primary={`${user.first_name} ${user.last_name}`}
                                            secondary={subtextFunction(user)}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            </Tooltip>
                        );
                    })}
                </List>
            </Box>
        </Paper>
    );
};

export default AssigneesList;
